import { colors } from '../../colors';
var imageSlider = {
  primaryBgColor: colors.lightTan,
  secondaryBgColor: colors.white,
  textColorDark: colors.smoke,
  textColorLight: colors.white
};
export default imageSlider;